import "./App.css";

function App() {
  return (
    <div className="app-shell">
      <header className="hero">
        <p className="eyebrow">The Catholic Church in Pakistan</p>
        <h1>Catholic Pakistan</h1>
        <p className="lede">
          Pakistan's roughly 1.6 million Catholics represent less than 1% of the population -- a small minority community known for its outsized role in education, healthcare, and service to the poor.
        </p>
        <div className="cta-row">
          <a href="#structure">
            Church Structure
          </a>
          <a href="#service" className="secondary">
            Community Service
          </a>
        </div>
      </header>

      <section className="cards">
        <article>
          <h2>A Small, Resilient Minority</h2>
          <p>
            Catholics number roughly 1,578,000 in Pakistan as of 2026 -- under 1% of the population -- organized across two archdioceses, four dioceses, and one apostolic vicariate, all Latin Rite.
          </p>
        </article>
        <article>
          <h2>Concentrated Communities</h2>
          <p>
            The largest Catholic communities are centered in Lahore (about 389,000 Catholics), Multan (about 310,000), and Islamabad-Rawalpindi (about 215,000).
          </p>
        </article>
        <article>
          <h2>A Legacy of Service</h2>
          <p>
            Despite minority status and real safety challenges, Pakistani Catholic institutions remain widely recognized for their work in education, healthcare, and emergency relief.
          </p>
        </article>
      </section>

      <section className="section" id="structure">
        <h2>Dioceses & Current Leadership</h2>
        <p className="section-sub">Pakistan's Catholic Church spans 2 episcopal territories, 4 suffragan dioceses, and an apostolic vicariate.</p>
        <div className="directory-list">
          <article className="directory-item">
            <h3>Archdiocese of Lahore</h3>
            <p>Archbishop Khalid Rehmat, installed 2026, Pakistan's youngest bishop</p>
          </article>
          <article className="directory-item">
            <h3>Apostolic Vicariate of Quetta</h3>
            <p>New bishop appointed alongside Lahore, March 2026</p>
          </article>
          <article className="directory-item">
            <h3>Archdiocese of Karachi</h3>
            <p>Pakistan's other archdiocese</p>
          </article>
          <article className="directory-item">
            <h3>Diocese of Islamabad-Rawalpindi</h3>
            <p>~215,000 Catholics</p>
          </article>
          <article className="directory-item">
            <h3>Diocese of Multan</h3>
            <p>~310,000 Catholics</p>
          </article>
        </div>
      </section>

      <section className="section" id="news">
        <h2>Latest News</h2>
        <p className="section-sub">Recent, sourced developments -- updated as new stories are verified.</p>
        <div className="news-list">
          <article className="news-item">
            <p className="news-date">March 10, 2026</p>
            <h3>Pope Leo XIV appoints new bishops for Lahore and Quetta</h3>
            <p>Archbishop-elect Khalid Rehmat was installed to lead the Archdiocese of Lahore, Pakistan's largest Catholic diocese, following a turbulent period; a new bishop was named for Quetta simultaneously.</p>
            <p className="news-source">Source: Catholic World Report, RVA</p>
          </article>
        </div>
      </section>
    </div>
  );
}

export default App;
